var heading_default = {
  "fontElementMap": "NjuAJ",
  "elementSpacing": "UkKbT",
  "headerOne": "IXQjY UkKbT",
  "headerTwo": "BvkOb UkKbT",
  "headerThree": "_2V6c8 UkKbT",
  "headerFour": "UfFV- UkKbT",
  "headerFive": "gA-9V UkKbT",
  "headerSix": "vIAS9 UkKbT",
  "child": "Y7ohM"
};
export {
  heading_default as default
};
//# sourceMappingURL=heading-scss.js.map
